(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root['ca-plateform-plateform-commons'] = factory(typeof this['ca-plateform-plateform-commons'] === 'undefined' ? {} : this['ca-plateform-plateform-commons']);
}(this, function (_) {
  //region block: imports
  var imul = Math.imul;
  //endregion
  'use strict';
  //region block: pre-declaration
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  NotFoundException.prototype = Object.create(Exception.prototype);
  NotFoundException.prototype.constructor = NotFoundException;
  //endregion
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function isNaN_0(_this__1828080292) {
    return !(_this__1828080292 === _this__1828080292);
  }
  function _get_buf__856886398() {
    init_properties_bitUtils_kt_782416278();
    return buf;
  }
  var buf;
  function _get_bufFloat64__3281801540() {
    init_properties_bitUtils_kt_782416278();
    return bufFloat64;
  }
  var bufFloat64;
  var bufFloat32;
  function _get_bufInt32__721419088() {
    init_properties_bitUtils_kt_782416278();
    return bufInt32;
  }
  var bufInt32;
  function _get_lowIndex__162050477() {
    init_properties_bitUtils_kt_782416278();
    return lowIndex;
  }
  var lowIndex;
  function _get_highIndex__2347002881() {
    init_properties_bitUtils_kt_782416278();
    return highIndex;
  }
  var highIndex;
  function getNumberHashCode(obj) {
    init_properties_bitUtils_kt_782416278();
    var tmp$ret$1;
    $l$block_0: {
      var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = tmp0_unsafeCast_0;
        break $l$block;
      }
      tmp$ret$1 = tmp$ret$0;
      break $l$block_0;
    }
    if (tmp$ret$1 === obj) {
      return numberToInt(obj);
    } else {
    }
    _get_bufFloat64__3281801540()[0] = obj;
    return imul(_get_bufInt32__721419088()[_get_highIndex__2347002881()], 31) + _get_bufInt32__721419088()[_get_lowIndex__162050477()] | 0;
  }
  var properties_initialized_bitUtils_kt_1092294842;
  function init_properties_bitUtils_kt_782416278() {
    if (!properties_initialized_bitUtils_kt_1092294842) {
      properties_initialized_bitUtils_kt_1092294842 = true;
      buf = new ArrayBuffer(8);
      var tmp$ret$1;
      $l$block_0: {
        var tmp0_unsafeCast_0 = new Float64Array(_get_buf__856886398());
        var tmp$ret$0;
        $l$block: {
          tmp$ret$0 = tmp0_unsafeCast_0;
          break $l$block;
        }
        tmp$ret$1 = tmp$ret$0;
        break $l$block_0;
      }
      bufFloat64 = tmp$ret$1;
      var tmp$ret$1_0;
      $l$block_2: {
        var tmp0_unsafeCast_0_0 = new Float32Array(_get_buf__856886398());
        var tmp$ret$0_0;
        $l$block_1: {
          tmp$ret$0_0 = tmp0_unsafeCast_0_0;
          break $l$block_1;
        }
        tmp$ret$1_0 = tmp$ret$0_0;
        break $l$block_2;
      }
      bufFloat32 = tmp$ret$1_0;
      var tmp$ret$1_1;
      $l$block_4: {
        var tmp0_unsafeCast_0_1 = new Int32Array(_get_buf__856886398());
        var tmp$ret$0_1;
        $l$block_3: {
          tmp$ret$0_1 = tmp0_unsafeCast_0_1;
          break $l$block_3;
        }
        tmp$ret$1_1 = tmp$ret$0_1;
        break $l$block_4;
      }
      bufInt32 = tmp$ret$1_1;
      var tmp$ret$1_2;
      $l$block_6: {
        {
        }
        var tmp$ret$0_2;
        $l$block_5: {
          _get_bufFloat64__3281801540()[0] = -1.0;
          tmp$ret$0_2 = !(_get_bufInt32__721419088()[0] === 0) ? 1 : 0;
          break $l$block_5;
        }
        tmp$ret$1_2 = tmp$ret$0_2;
        break $l$block_6;
      }
      lowIndex = tmp$ret$1_2;
      highIndex = 1 - _get_lowIndex__162050477() | 0;
    }
  }
  function equals(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }
    if (obj2 == null) {
      return false;
    }
    if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }
    if (obj1 !== obj1) {
      return obj2 !== obj2;
    }
    if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp$ret$0;
          $l$block: {
            tmp$ret$0 = 1;
            break $l$block;
          }
          var tmp_1 = tmp$ret$0 / obj1;
          var tmp$ret$1;
          $l$block_0: {
            tmp$ret$1 = 1;
            break $l$block_0;
          }
          tmp_0 = tmp_1 === tmp$ret$1 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }
    return obj1 === obj2;
  }
  function toString(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp$ret$0;
      $l$block: {
        var tmp0_unsafeCast_0 = o.toString();
        tmp$ret$0 = tmp0_unsafeCast_0;
        break $l$block;
      }
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      var tmp$ret$0;
      $l$block: {
        tmp$ret$0 = instance;
        break $l$block;
      }
      tmp$ret$0.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }
    if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }
    this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function Companion() {
    Companion_instance = this;
    this.MIN_VALUE_1 = new Long(0, -2147483648);
    this.MAX_VALUE_1 = new Long(-1, 2147483647);
    this.SIZE_BYTES_1 = 8;
    this.SIZE_BITS_1 = 64;
  }
  Companion.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Long(low, high) {
    Companion_getInstance();
    Number_0.call(this);
    this.low_1 = low;
    this.high_1 = high;
  }
  Long.prototype._get_low__857179069_e6cblp_k$ = function () {
    return this.low_1;
  };
  Long.prototype._get_high__798860521_d7mcq1_k$ = function () {
    return this.high_1;
  };
  Long.prototype.plus_u6jwas_k$ = function (other) {
    return add(this, other);
  };
  Long.prototype.div_9s1fi3_k$ = function (other) {
    return divide(this, other);
  };
  Long.prototype.unaryMinus_6uz0qp_k$ = function () {
    return this.inv_28kx_k$().plus_u6jwas_k$(new Long(1, 0));
  };
  Long.prototype.inv_28kx_k$ = function () {
    return new Long(~this.low_1, ~this.high_1);
  };
  Long.prototype.toInt_1tsl84_k$ = function () {
    return this.low_1;
  };
  Long.prototype.toDouble_ygsx0s_k$ = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_ygsx0s_k$();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _get_ZERO__784837795() {
    init_properties_longjs_kt_2491794837();
    return ZERO;
  }
  var ZERO;
  function _get_ONE__856281867() {
    init_properties_longjs_kt_2491794837();
    return ONE;
  }
  var ONE;
  function _get_NEG_ONE__3857310458() {
    init_properties_longjs_kt_2491794837();
    return NEG_ONE;
  }
  var NEG_ONE;
  function _get_MAX_VALUE__3201573499() {
    init_properties_longjs_kt_2491794837();
    return MAX_VALUE;
  }
  var MAX_VALUE;
  function _get_MIN_VALUE__1378605517() {
    init_properties_longjs_kt_2491794837();
    return MIN_VALUE;
  }
  var MIN_VALUE;
  function _get_TWO_PWR_24___3968246811() {
    init_properties_longjs_kt_2491794837();
    return TWO_PWR_24_;
  }
  var TWO_PWR_24_;
  function compare(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    if (equalsLong(_this__1828080292, other)) {
      return 0;
    }
    var thisNeg = isNegative(_this__1828080292);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this__1828080292, other)) ? -1 : 1;
  }
  function add(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    var a48 = _this__1828080292._get_high__798860521_d7mcq1_k$() >>> 16 | 0;
    var a32 = _this__1828080292._get_high__798860521_d7mcq1_k$() & 65535;
    var a16 = _this__1828080292._get_low__857179069_e6cblp_k$() >>> 16 | 0;
    var a00 = _this__1828080292._get_low__857179069_e6cblp_k$() & 65535;
    var b48 = other._get_high__798860521_d7mcq1_k$() >>> 16 | 0;
    var b32 = other._get_high__798860521_d7mcq1_k$() & 65535;
    var b16 = other._get_low__857179069_e6cblp_k$() >>> 16 | 0;
    var b00 = other._get_low__857179069_e6cblp_k$() & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return add(_this__1828080292, other.unaryMinus_6uz0qp_k$());
  }
  function multiply(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    if (isZero(_this__1828080292)) {
      return _get_ZERO__784837795();
    } else if (isZero(other)) {
      return _get_ZERO__784837795();
    }
    if (equalsLong(_this__1828080292, _get_MIN_VALUE__1378605517())) {
      return isOdd(other) ? _get_MIN_VALUE__1378605517() : _get_ZERO__784837795();
    } else if (equalsLong(other, _get_MIN_VALUE__1378605517())) {
      return isOdd(_this__1828080292) ? _get_MIN_VALUE__1378605517() : _get_ZERO__784837795();
    }
    if (isNegative(_this__1828080292)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this__1828080292), negate(other));
      } else {
        tmp = negate(multiply(negate(_this__1828080292), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this__1828080292, negate(other)));
    }
    if (lessThan(_this__1828080292, _get_TWO_PWR_24___3968246811()) ? lessThan(other, _get_TWO_PWR_24___3968246811()) : false) {
      return fromNumber(toNumber(_this__1828080292) * toNumber(other));
    }
    var a48 = _this__1828080292._get_high__798860521_d7mcq1_k$() >>> 16 | 0;
    var a32 = _this__1828080292._get_high__798860521_d7mcq1_k$() & 65535;
    var a16 = _this__1828080292._get_low__857179069_e6cblp_k$() >>> 16 | 0;
    var a00 = _this__1828080292._get_low__857179069_e6cblp_k$() & 65535;
    var b48 = other._get_high__798860521_d7mcq1_k$() >>> 16 | 0;
    var b32 = other._get_high__798860521_d7mcq1_k$() & 65535;
    var b16 = other._get_low__857179069_e6cblp_k$() >>> 16 | 0;
    var b00 = other._get_low__857179069_e6cblp_k$() & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this__1828080292)) {
      return _get_ZERO__784837795();
    }
    if (equalsLong(_this__1828080292, _get_MIN_VALUE__1378605517())) {
      if (equalsLong(other, _get_ONE__856281867()) ? true : equalsLong(other, _get_NEG_ONE__3857310458())) {
        return _get_MIN_VALUE__1378605517();
      } else if (equalsLong(other, _get_MIN_VALUE__1378605517())) {
        return _get_ONE__856281867();
      } else {
        var halfThis = shiftRight(_this__1828080292, 1);
        var approx = shiftLeft(halfThis.div_9s1fi3_k$(other), 1);
        if (equalsLong(approx, _get_ZERO__784837795())) {
          return isNegative(other) ? _get_ONE__856281867() : _get_NEG_ONE__3857310458();
        } else {
          var rem = subtract(_this__1828080292, multiply(other, approx));
          return add(approx, rem.div_9s1fi3_k$(other));
        }
      }
    } else if (equalsLong(other, _get_MIN_VALUE__1378605517())) {
      return _get_ZERO__784837795();
    }
    if (isNegative(_this__1828080292)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this__1828080292).div_9s1fi3_k$(negate(other));
      } else {
        tmp = negate(negate(_this__1828080292).div_9s1fi3_k$(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this__1828080292.div_9s1fi3_k$(negate(other)));
    }
    var res = _get_ZERO__784837795();
    var rem_0 = _this__1828080292;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta = log2 <= 48.0 ? 1.0 : Math.pow(2.0, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = _get_ONE__856281867();
      }
      res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function shiftLeft(_this__1828080292, numBits) {
    init_properties_longjs_kt_2491794837();
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this__1828080292;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this__1828080292._get_low__857179069_e6cblp_k$() << numBits_0, _this__1828080292._get_high__798860521_d7mcq1_k$() << numBits_0 | (_this__1828080292._get_low__857179069_e6cblp_k$() >>> (32 - numBits_0 | 0) | 0));
      } else {
        return new Long(0, _this__1828080292._get_low__857179069_e6cblp_k$() << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this__1828080292, numBits) {
    init_properties_longjs_kt_2491794837();
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this__1828080292;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this__1828080292._get_low__857179069_e6cblp_k$() >>> numBits_0 | 0 | _this__1828080292._get_high__798860521_d7mcq1_k$() << (32 - numBits_0 | 0), _this__1828080292._get_high__798860521_d7mcq1_k$() >> numBits_0);
      } else {
        return new Long(_this__1828080292._get_high__798860521_d7mcq1_k$() >> (numBits_0 - 32 | 0), _this__1828080292._get_high__798860521_d7mcq1_k$() >= 0 ? 0 : -1);
      }
    }
  }
  function toNumber(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_high__798860521_d7mcq1_k$() * 4.294967296E9 + getLowBitsUnsigned(_this__1828080292);
  }
  function equalsLong(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_high__798860521_d7mcq1_k$() === other._get_high__798860521_d7mcq1_k$() ? _this__1828080292._get_low__857179069_e6cblp_k$() === other._get_low__857179069_e6cblp_k$() : false;
  }
  function hashCode(l) {
    init_properties_longjs_kt_2491794837();
    return l._get_low__857179069_e6cblp_k$() ^ l._get_high__798860521_d7mcq1_k$();
  }
  function toStringImpl(_this__1828080292, radix) {
    init_properties_longjs_kt_2491794837();
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('radix out of range: ' + radix);
    }
    if (isZero(_this__1828080292)) {
      return '0';
    }
    if (isNegative(_this__1828080292)) {
      if (equalsLong(_this__1828080292, _get_MIN_VALUE__1378605517())) {
        var radixLong = fromInt(radix);
        var div = _this__1828080292.div_9s1fi3_k$(radixLong);
        var rem = subtract(multiply(div, radixLong), _this__1828080292).toInt_1tsl84_k$();
        var tmp = toStringImpl(div, radix);
        var tmp$ret$1;
        $l$block_0: {
          var tmp$ret$0;
          $l$block: {
            tmp$ret$0 = rem;
            break $l$block;
          }
          var tmp0_unsafeCast_0 = tmp$ret$0.toString(radix);
          tmp$ret$1 = tmp0_unsafeCast_0;
          break $l$block_0;
        }
        return tmp + tmp$ret$1;
      } else {
        return '-' + toStringImpl(negate(_this__1828080292), radix);
      }
    }
    var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this__1828080292;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_9s1fi3_k$(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_1tsl84_k$();
      var tmp$ret$3;
      $l$block_2: {
        var tmp$ret$2;
        $l$block_1: {
          tmp$ret$2 = intval;
          break $l$block_1;
        }
        var tmp1_unsafeCast_0 = tmp$ret$2.toString(radix);
        tmp$ret$3 = tmp1_unsafeCast_0;
        break $l$block_2;
      }
      var digits = tmp$ret$3;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    init_properties_longjs_kt_2491794837();
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_high__798860521_d7mcq1_k$() < 0;
  }
  function isZero(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_high__798860521_d7mcq1_k$() === 0 ? _this__1828080292._get_low__857179069_e6cblp_k$() === 0 : false;
  }
  function isOdd(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return (_this__1828080292._get_low__857179069_e6cblp_k$() & 1) === 1;
  }
  function negate(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292.unaryMinus_6uz0qp_k$();
  }
  function lessThan(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return compare(_this__1828080292, other) < 0;
  }
  function fromNumber(value) {
    init_properties_longjs_kt_2491794837();
    if (isNaN_0(value)) {
      return _get_ZERO__784837795();
    } else if (value <= -9.223372036854776E18) {
      return _get_MIN_VALUE__1378605517();
    } else if (value + 1 >= 9.223372036854776E18) {
      return _get_MAX_VALUE__3201573499();
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return compare(_this__1828080292, other) > 0;
  }
  function greaterThanOrEqual(_this__1828080292, other) {
    init_properties_longjs_kt_2491794837();
    return compare(_this__1828080292, other) >= 0;
  }
  function getLowBitsUnsigned(_this__1828080292) {
    init_properties_longjs_kt_2491794837();
    return _this__1828080292._get_low__857179069_e6cblp_k$() >= 0 ? _this__1828080292._get_low__857179069_e6cblp_k$() : 4.294967296E9 + _this__1828080292._get_low__857179069_e6cblp_k$();
  }
  var properties_initialized_longjs_kt_320052665;
  function init_properties_longjs_kt_2491794837() {
    if (!properties_initialized_longjs_kt_320052665) {
      properties_initialized_longjs_kt_320052665 = true;
      ZERO = fromInt(0);
      ONE = fromInt(1);
      NEG_ONE = fromInt(-1);
      MAX_VALUE = new Long(-1, 2147483647);
      MIN_VALUE = new Long(0, -2147483648);
      TWO_PWR_24_ = fromInt(16777216);
    }
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_1tsl84_k$();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp$ret$0;
      $l$block: {
        var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
        tmp$ret$0 = tmp0_unsafeCast_0;
        break $l$block;
      }
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = Array.isArray(obj);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = jsBitwiseOr$outlinedJsCode$(lhs_hack, rhs_hack);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function jsTypeOf(value_hack) {
    var tmp$ret$0;
    $l$block: {
      var tmp0_unsafeCast_0 = jsTypeOf$outlinedJsCode$(value_hack);
      tmp$ret$0 = tmp0_unsafeCast_0;
      break $l$block;
    }
    return tmp$ret$0;
  }
  function jsBitwiseOr$outlinedJsCode$(lhs_hack, rhs_hack) {
    return lhs_hack | rhs_hack;
  }
  function jsTypeOf$outlinedJsCode$(value_hack) {
    return typeof value_hack;
  }
  function Alert() {
  }
  Alert.$metadata$ = {
    simpleName: 'Alert',
    kind: 'interface',
    interfaces: []
  };
  function AlertSeverity(severity) {
    this.severity_1 = severity;
  }
  AlertSeverity.prototype._get_severity__64506990_12elwu_k$ = function () {
    return this.severity_1;
  };
  AlertSeverity.$metadata$ = {
    simpleName: 'AlertSeverity',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AlertSeverity.prototype, 'severity', {
    configurable: true,
    get: AlertSeverity.prototype._get_severity__64506990_12elwu_k$
  });
  function Attachment() {
  }
  Attachment.$metadata$ = {
    simpleName: 'Attachment',
    kind: 'interface',
    interfaces: []
  };
  function Command() {
  }
  Command.$metadata$ = {
    simpleName: 'Command',
    kind: 'interface',
    interfaces: []
  };
  function DateInterval() {
  }
  DateInterval.$metadata$ = {
    simpleName: 'DateInterval',
    kind: 'interface',
    interfaces: []
  };
  function Event() {
  }
  Event.$metadata$ = {
    simpleName: 'Event',
    kind: 'interface',
    interfaces: []
  };
  function GeoLocation() {
  }
  GeoLocation.$metadata$ = {
    simpleName: 'GeoLocation',
    kind: 'interface',
    interfaces: []
  };
  function GeoStamp() {
  }
  GeoStamp.$metadata$ = {
    simpleName: 'GeoStamp',
    kind: 'interface',
    interfaces: []
  };
  function Page() {
  }
  Page.$metadata$ = {
    simpleName: 'Page',
    kind: 'interface',
    interfaces: []
  };
  function PageRequest() {
  }
  PageRequest.$metadata$ = {
    simpleName: 'PageRequest',
    kind: 'interface',
    interfaces: []
  };
  function AlertBase(type, description, date, payload, severity) {
    this.type_1 = type;
    this.description_1 = description;
    this.date_1 = date;
    this.payload_1 = payload;
    this.severity_1 = severity;
  }
  AlertBase.prototype._get_type__810427985_deia8h_k$ = function () {
    return this.type_1;
  };
  AlertBase.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  AlertBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  AlertBase.prototype._get_payload__3508054851_d0i9j1_k$ = function () {
    return this.payload_1;
  };
  AlertBase.prototype._get_severity__64506990_12elwu_k$ = function () {
    return this.severity_1;
  };
  AlertBase.prototype.toString = function () {
    return "AlertBase(type='" + this.type + "', description='" + this.description + "', date='" + this.date + "', payload=" + this.payload + ', severity=' + this.severity + ')';
  };
  AlertBase.$metadata$ = {
    simpleName: 'AlertBase',
    kind: 'class',
    interfaces: [Alert]
  };
  Object.defineProperty(AlertBase.prototype, 'type', {
    configurable: true,
    get: function () {
      return this._get_type__810427985_deia8h_k$();
    }
  });
  Object.defineProperty(AlertBase.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  Object.defineProperty(AlertBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  Object.defineProperty(AlertBase.prototype, 'payload', {
    configurable: true,
    get: function () {
      return this._get_payload__3508054851_d0i9j1_k$();
    }
  });
  Object.defineProperty(AlertBase.prototype, 'severity', {
    configurable: true,
    get: function () {
      return this._get_severity__64506990_12elwu_k$();
    }
  });
  function DateIntervalBase(startDate, endDate) {
    this.startDate_1 = startDate;
    this.endDate_1 = endDate;
  }
  DateIntervalBase.prototype._get_startDate__1388556577_mypl41_k$ = function () {
    return this.startDate_1;
  };
  DateIntervalBase.prototype._get_endDate__3826071816_7r622g_k$ = function () {
    return this.endDate_1;
  };
  DateIntervalBase.prototype.component1 = function () {
    return this.startDate_1;
  };
  DateIntervalBase.prototype.component2 = function () {
    return this.endDate_1;
  };
  DateIntervalBase.prototype.copy = function (startDate, endDate) {
    return this.copy_j05hop_k$(startDate === void 1 ? this.startDate_1 : startDate, endDate === void 1 ? this.endDate_1 : endDate);
  };
  DateIntervalBase.prototype.copy_j05hop_k$ = function (startDate, endDate) {
    return new DateIntervalBase(startDate, endDate);
  };
  DateIntervalBase.prototype.copy$default_75mnvg_k$ = function (startDate, endDate, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      startDate = this.startDate_1;
    if (!(($mask0 & 2) === 0))
      endDate = this.endDate_1;
    return this.copy_j05hop_k$(startDate, endDate);
  };
  DateIntervalBase.prototype.toString = function () {
    return 'DateIntervalBase(startDate=' + toString(this.startDate_1) + ', endDate=' + toString(this.endDate_1) + ')';
  };
  DateIntervalBase.prototype.hashCode = function () {
    var result = this.startDate_1.hashCode();
    result = imul(result, 31) + this.endDate_1.hashCode() | 0;
    return result;
  };
  DateIntervalBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DateIntervalBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DateIntervalBase ? other : THROW_CCE();
    if (!this.startDate_1.equals(tmp0_other_with_cast.startDate_1))
      return false;
    if (!this.endDate_1.equals(tmp0_other_with_cast.endDate_1))
      return false;
    return true;
  };
  DateIntervalBase.$metadata$ = {
    simpleName: 'DateIntervalBase',
    kind: 'class',
    interfaces: [DateInterval]
  };
  Object.defineProperty(DateIntervalBase.prototype, 'startDate', {
    configurable: true,
    get: function () {
      return this._get_startDate__1388556577_mypl41_k$();
    }
  });
  Object.defineProperty(DateIntervalBase.prototype, 'endDate', {
    configurable: true,
    get: function () {
      return this._get_endDate__3826071816_7r622g_k$();
    }
  });
  function GeoLocationBase(lon, lat) {
    this.lon_1 = lon;
    this.lat_1 = lat;
  }
  GeoLocationBase.prototype._get_lon__857178790_e6cbdy_k$ = function () {
    return this.lon_1;
  };
  GeoLocationBase.prototype._get_lat__857165522_e6c15e_k$ = function () {
    return this.lat_1;
  };
  GeoLocationBase.prototype.component1 = function () {
    return this.lon_1;
  };
  GeoLocationBase.prototype.component2 = function () {
    return this.lat_1;
  };
  GeoLocationBase.prototype.copy = function (lon, lat) {
    return this.copy_fws33n_k$(lon === void 1 ? this.lon_1 : lon, lat === void 1 ? this.lat_1 : lat);
  };
  GeoLocationBase.prototype.copy_fws33n_k$ = function (lon, lat) {
    return new GeoLocationBase(lon, lat);
  };
  GeoLocationBase.prototype.copy$default_l1hfaq_k$ = function (lon, lat, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      lon = this.lon_1;
    if (!(($mask0 & 2) === 0))
      lat = this.lat_1;
    return this.copy_fws33n_k$(lon, lat);
  };
  GeoLocationBase.prototype.toString = function () {
    return 'GeoLocationBase(lon=' + this.lon_1 + ', lat=' + this.lat_1 + ')';
  };
  GeoLocationBase.prototype.hashCode = function () {
    var result = getNumberHashCode(this.lon_1);
    result = imul(result, 31) + getNumberHashCode(this.lat_1) | 0;
    return result;
  };
  GeoLocationBase.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GeoLocationBase))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GeoLocationBase ? other : THROW_CCE();
    if (!equals(this.lon_1, tmp0_other_with_cast.lon_1))
      return false;
    if (!equals(this.lat_1, tmp0_other_with_cast.lat_1))
      return false;
    return true;
  };
  GeoLocationBase.$metadata$ = {
    simpleName: 'GeoLocationBase',
    kind: 'class',
    interfaces: [GeoLocation]
  };
  Object.defineProperty(GeoLocationBase.prototype, 'lon', {
    configurable: true,
    get: function () {
      return this._get_lon__857178790_e6cbdy_k$();
    }
  });
  Object.defineProperty(GeoLocationBase.prototype, 'lat', {
    configurable: true,
    get: function () {
      return this._get_lat__857165522_e6c15e_k$();
    }
  });
  function GeoStampBase(date, location) {
    this.date_1 = date;
    this.location_1 = location;
  }
  GeoStampBase.prototype._get_date__794940509_d5ac0t_k$ = function () {
    return this.date_1;
  };
  GeoStampBase.prototype._get_location__284645046_4pgxiu_k$ = function () {
    return this.location_1;
  };
  GeoStampBase.$metadata$ = {
    simpleName: 'GeoStampBase',
    kind: 'class',
    interfaces: [GeoStamp]
  };
  Object.defineProperty(GeoStampBase.prototype, 'date', {
    configurable: true,
    get: function () {
      return this._get_date__794940509_d5ac0t_k$();
    }
  });
  Object.defineProperty(GeoStampBase.prototype, 'location', {
    configurable: true,
    get: function () {
      return this._get_location__284645046_4pgxiu_k$();
    }
  });
  function PageBase(page, size, total, list) {
    this.page_1 = page;
    this.size_1 = size;
    this.total_1 = total;
    this.list_1 = list;
  }
  PageBase.prototype._get_page__806010268_dbvli4_k$ = function () {
    return this.page_1;
  };
  PageBase.prototype._get_size__809037418_ddoh9m_k$ = function () {
    return this.size_1;
  };
  PageBase.prototype._get_total__3639312653_aucycz_k$ = function () {
    return this.total_1;
  };
  PageBase.prototype._get_list__802566509_d9tsa5_k$ = function () {
    return this.list_1;
  };
  PageBase.$metadata$ = {
    simpleName: 'PageBase',
    kind: 'class',
    interfaces: [Page]
  };
  Object.defineProperty(PageBase.prototype, 'page', {
    configurable: true,
    get: function () {
      return this._get_page__806010268_dbvli4_k$();
    }
  });
  Object.defineProperty(PageBase.prototype, 'size', {
    configurable: true,
    get: function () {
      return this._get_size__809037418_ddoh9m_k$();
    }
  });
  Object.defineProperty(PageBase.prototype, 'total', {
    configurable: true,
    get: function () {
      return this._get_total__3639312653_aucycz_k$();
    }
  });
  Object.defineProperty(PageBase.prototype, 'list', {
    configurable: true,
    get: function () {
      return this._get_list__802566509_d9tsa5_k$();
    }
  });
  function PageRequestBase(page, size) {
    this.page_1 = page;
    this.size_1 = size;
  }
  PageRequestBase.prototype._get_page__806010268_dbvli4_k$ = function () {
    return this.page_1;
  };
  PageRequestBase.prototype._get_size__809037418_ddoh9m_k$ = function () {
    return this.size_1;
  };
  PageRequestBase.$metadata$ = {
    simpleName: 'PageRequestBase',
    kind: 'class',
    interfaces: [PageRequest]
  };
  Object.defineProperty(PageRequestBase.prototype, 'page', {
    configurable: true,
    get: function () {
      return this._get_page__806010268_dbvli4_k$();
    }
  });
  Object.defineProperty(PageRequestBase.prototype, 'size', {
    configurable: true,
    get: function () {
      return this._get_size__809037418_ddoh9m_k$();
    }
  });
  function _get_ROLE_ADMIN__3149651749() {
    return ROLE_ADMIN;
  }
  var ROLE_ADMIN;
  function _get_ROLE_SUPER_ADMIN__3554080777() {
    return ROLE_SUPER_ADMIN;
  }
  var ROLE_SUPER_ADMIN;
  function _get_ROLE_OPERATOR_ADMIN__1787221876() {
    return ROLE_OPERATOR_ADMIN;
  }
  var ROLE_OPERATOR_ADMIN;
  function _get_ROLE_OPERATOR_USER__1600582830() {
    return ROLE_OPERATOR_USER;
  }
  var ROLE_OPERATOR_USER;
  function _get_ROLE_OPERATOR_ADMIN_ONBOARDING__962210510() {
    return ROLE_OPERATOR_ADMIN_ONBOARDING;
  }
  var ROLE_OPERATOR_ADMIN_ONBOARDING;
  function _get_ROLE_OPERATOR_USER_ONBOARDING__1450534228() {
    return ROLE_OPERATOR_USER_ONBOARDING;
  }
  var ROLE_OPERATOR_USER_ONBOARDING;
  function _get_ROLE_FUNDER_ADMIN__3418638502() {
    return ROLE_FUNDER_ADMIN;
  }
  var ROLE_FUNDER_ADMIN;
  function _get_ROLE_FUNDER_USER__821925180() {
    return ROLE_FUNDER_USER;
  }
  var ROLE_FUNDER_USER;
  function _get_ROLE_CARRIER_ADMIN__3637737580() {
    return ROLE_CARRIER_ADMIN;
  }
  var ROLE_CARRIER_ADMIN;
  function _get_ROLE_CARRIER_USER__2768655542() {
    return ROLE_CARRIER_USER;
  }
  var ROLE_CARRIER_USER;
  function _get_ROLE_TMS_ADMIN__3958562570() {
    return ROLE_TMS_ADMIN;
  }
  var ROLE_TMS_ADMIN;
  function _get_ROLE_TMS_USER__3610288728() {
    return ROLE_TMS_USER;
  }
  var ROLE_TMS_USER;
  function _get_ROLE_VISITOR_ADMIN__635253302() {
    return ROLE_VISITOR_ADMIN;
  }
  var ROLE_VISITOR_ADMIN;
  function _get_ROLE_VISITOR_USER__39401900() {
    return ROLE_VISITOR_USER;
  }
  var ROLE_VISITOR_USER;
  function _get_ROLE_READ_HEAT_MAP__2334907966() {
    return ROLE_READ_HEAT_MAP;
  }
  var ROLE_READ_HEAT_MAP;
  function _get_ROLE_READ_FLUX_MAP__1654341093() {
    return ROLE_READ_FLUX_MAP;
  }
  var ROLE_READ_FLUX_MAP;
  function _get_ROLE_READ_DASHBOARD_BONUS_TOTAL__3980768280() {
    return ROLE_READ_DASHBOARD_BONUS_TOTAL;
  }
  var ROLE_READ_DASHBOARD_BONUS_TOTAL;
  function _get_ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE__961309144() {
    return ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE;
  }
  var ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE;
  function _get_ROLE_READ_DASHBOARD_DELIVERY_TIME__1042262468() {
    return ROLE_READ_DASHBOARD_DELIVERY_TIME;
  }
  var ROLE_READ_DASHBOARD_DELIVERY_TIME;
  function _get_ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES__628138737() {
    return ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES;
  }
  var ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES;
  function _get_ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT__3236390426() {
    return ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT;
  }
  var ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT;
  function _get_ROLE_READ_DASHBOARD_HUB_COUNT__3178299799() {
    return ROLE_READ_DASHBOARD_HUB_COUNT;
  }
  var ROLE_READ_DASHBOARD_HUB_COUNT;
  function _get_ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE__1081766482() {
    return ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE;
  }
  var ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE;
  function _get_ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY__2332509822() {
    return ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY;
  }
  var ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY;
  function _get_ROLE_READ_DASHBOARD_TOUR_AMOUNT__144310845() {
    return ROLE_READ_DASHBOARD_TOUR_AMOUNT;
  }
  var ROLE_READ_DASHBOARD_TOUR_AMOUNT;
  function _get_ROLE_READ_DASHBOARD_DISTANCE_TOTAL__2048129574() {
    return ROLE_READ_DASHBOARD_DISTANCE_TOTAL;
  }
  var ROLE_READ_DASHBOARD_DISTANCE_TOTAL;
  function _get_ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED__1801289601() {
    return ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED;
  }
  var ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED;
  function _get_ROLE_READ_DASHBOARD_CO2_AVOIDED__3570012961() {
    return ROLE_READ_DASHBOARD_CO2_AVOIDED;
  }
  var ROLE_READ_DASHBOARD_CO2_AVOIDED;
  function _get_ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED__3490441090() {
    return ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED;
  }
  var ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED;
  function NotFoundException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, NotFoundException);
  }
  NotFoundException.$metadata$ = {
    simpleName: 'NotFoundException',
    kind: 'class',
    interfaces: []
  };
  //region block: init
  ROLE_ADMIN = 'admin';
  ROLE_SUPER_ADMIN = 'super_admin';
  ROLE_OPERATOR_ADMIN = 'operator_admin';
  ROLE_OPERATOR_USER = 'operator_user';
  ROLE_OPERATOR_ADMIN_ONBOARDING = 'operator_admin_onboarding';
  ROLE_OPERATOR_USER_ONBOARDING = 'operator_user_onboarding';
  ROLE_FUNDER_ADMIN = 'funder_admin';
  ROLE_FUNDER_USER = 'funder_user';
  ROLE_CARRIER_ADMIN = 'carrier_admin';
  ROLE_CARRIER_USER = 'carrier_user';
  ROLE_TMS_ADMIN = 'tms_admin';
  ROLE_TMS_USER = 'tms_user';
  ROLE_VISITOR_ADMIN = 'visitor_admin';
  ROLE_VISITOR_USER = 'visitor_user';
  ROLE_READ_HEAT_MAP = 'read_heatmap';
  ROLE_READ_FLUX_MAP = 'read_flux_map';
  ROLE_READ_DASHBOARD_BONUS_TOTAL = 'read_dashboard_bonus_total';
  ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE = 'read_dashboard_bonus_per_package';
  ROLE_READ_DASHBOARD_DELIVERY_TIME = 'read_dashboard_delivery_time';
  ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES = 'read_dashboard_active_deliveries';
  ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT = 'read_dashboard_active_pack_count';
  ROLE_READ_DASHBOARD_HUB_COUNT = 'read_dashboard_hub_count';
  ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE = 'read_dashboard_average_approach_distance';
  ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY = 'read_dashboard_average_distance_per_delivery';
  ROLE_READ_DASHBOARD_TOUR_AMOUNT = 'read_dashboard_tour_amount';
  ROLE_READ_DASHBOARD_DISTANCE_TOTAL = 'read_dashboard_distance_total';
  ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED = 'read_dashboard_thermal_km_avoided';
  ROLE_READ_DASHBOARD_CO2_AVOIDED = 'read_dashboard_co2_avoided';
  ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED = 'read_dashboard_nox_ppm_avoided';
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    $city$colisactiv$platform$commons.AlertSeverity = AlertSeverity;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.AlertBase = AlertBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.DateIntervalBase = DateIntervalBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.GeoLocationBase = GeoLocationBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.GeoStampBase = GeoStampBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.PageBase = PageBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$base = $city$colisactiv$platform$commons.base || ($city$colisactiv$platform$commons.base = {});
    $city$colisactiv$platform$commons$base.PageRequestBase = PageRequestBase;
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$constants = $city$colisactiv$platform$commons.constants || ($city$colisactiv$platform$commons.constants = {});
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_ADMIN', {
      configurable: true,
      get: _get_ROLE_ADMIN__3149651749
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_SUPER_ADMIN', {
      configurable: true,
      get: _get_ROLE_SUPER_ADMIN__3554080777
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_OPERATOR_ADMIN', {
      configurable: true,
      get: _get_ROLE_OPERATOR_ADMIN__1787221876
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_OPERATOR_USER', {
      configurable: true,
      get: _get_ROLE_OPERATOR_USER__1600582830
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_OPERATOR_ADMIN_ONBOARDING', {
      configurable: true,
      get: _get_ROLE_OPERATOR_ADMIN_ONBOARDING__962210510
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_OPERATOR_USER_ONBOARDING', {
      configurable: true,
      get: _get_ROLE_OPERATOR_USER_ONBOARDING__1450534228
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_FUNDER_ADMIN', {
      configurable: true,
      get: _get_ROLE_FUNDER_ADMIN__3418638502
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_FUNDER_USER', {
      configurable: true,
      get: _get_ROLE_FUNDER_USER__821925180
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_CARRIER_ADMIN', {
      configurable: true,
      get: _get_ROLE_CARRIER_ADMIN__3637737580
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_CARRIER_USER', {
      configurable: true,
      get: _get_ROLE_CARRIER_USER__2768655542
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_TMS_ADMIN', {
      configurable: true,
      get: _get_ROLE_TMS_ADMIN__3958562570
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_TMS_USER', {
      configurable: true,
      get: _get_ROLE_TMS_USER__3610288728
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_VISITOR_ADMIN', {
      configurable: true,
      get: _get_ROLE_VISITOR_ADMIN__635253302
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_VISITOR_USER', {
      configurable: true,
      get: _get_ROLE_VISITOR_USER__39401900
    });
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$constants = $city$colisactiv$platform$commons.constants || ($city$colisactiv$platform$commons.constants = {});
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_HEATMAP', {
      configurable: true,
      get: _get_ROLE_READ_HEAT_MAP__2334907966
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_FLUX_MAP', {
      configurable: true,
      get: _get_ROLE_READ_FLUX_MAP__1654341093
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_BONUS_TOTAL', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_BONUS_TOTAL__3980768280
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_BONUS_PER_PACKAGE__961309144
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_DELIVERY_TIME', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_DELIVERY_TIME__1042262468
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_ACTIVE_DELIVERIES__628138737
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_ACTIVE_PACK_COUNT__3236390426
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_HUB_COUNT', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_HUB_COUNT__3178299799
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_AVERAGE_APPROACH_DISTANCE__1081766482
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_AVERAGE_DISTANCE_PER_DELIVERY__2332509822
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_TOUR_AMOUNT', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_TOUR_AMOUNT__144310845
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_DISTANCE_TOTAL', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_DISTANCE_TOTAL__2048129574
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_THERMAL_KM_AVOIDED__1801289601
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_CO2_AVOIDED', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_CO2_AVOIDED__3570012961
    });
    Object.defineProperty($city$colisactiv$platform$commons$constants, 'ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED', {
      configurable: true,
      get: _get_ROLE_READ_DASHBOARD_NOX_PPM_AVOIDED__3490441090
    });
    var $city = _.city || (_.city = {});
    var $city$colisactiv = $city.colisactiv || ($city.colisactiv = {});
    var $city$colisactiv$platform = $city$colisactiv.platform || ($city$colisactiv.platform = {});
    var $city$colisactiv$platform$commons = $city$colisactiv$platform.commons || ($city$colisactiv$platform.commons = {});
    var $city$colisactiv$platform$commons$exception = $city$colisactiv$platform$commons.exception || ($city$colisactiv$platform$commons.exception = {});
    $city$colisactiv$platform$commons$exception.NotFoundException = NotFoundException;
  }
  $jsExportAll$(_);
  //endregion
  return _;
}));

//# sourceMappingURL=ca-plateform-plateform-commons.js.map